import { render, staticRenderFns } from "./event-detail-guest.vue?vue&type=template&id=2fdd05bd&scoped=true&"
import script from "./event-detail-guest.vue?vue&type=script&lang=js&"
export * from "./event-detail-guest.vue?vue&type=script&lang=js&"
import style0 from "./event-detail-guest.vue?vue&type=style&index=0&id=2fdd05bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdd05bd",
  null
  
)

export default component.exports